/* eslint-disable */
import { produce } from "immer";
import {
  FUNDS_SAVINGS_FETCH_START,
  FUNDS_SAVINGS_FETCH_SUCCESS,
  FUNDS_SAVINGS_FETCH_FAILURE,
} from "../actions/types";

const fundsSavings = (
  state = {
    savingsFundFetching: false,
    savingsFundData: [],
    savingsFundError: null,
  },
  action,
) => {
  switch (action.type) {
    case FUNDS_SAVINGS_FETCH_START:
      return produce(state, (draft) => {
        draft.savingsFundFetching = true;
      });
    case FUNDS_SAVINGS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.savingsFundFetching = true;
        draft.savingsFundData = action.data;
        draft.savingsFundFetching = false;
      });
    case FUNDS_SAVINGS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.savingsFundFetching = false;
        draft.savingsFundError = action.error;
      });
    default:
      return state;
  }
};

export default fundsSavings;
